import PropTypes from "prop-types";
import React from "react";
import { Navigate } from "react-router-dom";

import LottieSpinner from "./LottieSpinner";

const EntrepreneurRoutes = ({ user, element }) => {
    if(!user) return <LottieSpinner />;
    if(!user.role) return <LottieSpinner />;
    if(user.role !== "entrepreneur") return <Navigate to="/unauthorized" />;
    return element;
};

EntrepreneurRoutes.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string,
    }),
    element: PropTypes.node.isRequired,
};

export default EntrepreneurRoutes;
